import { ParsedUrlQuery } from 'querystring';

export function getAvailableFrom(query: ParsedUrlQuery) {
    if (query['available_from']) {
        return query['available_from'];
    }

    return '';
}
